import React, { useEffect, useRef, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import addIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import { MODULE_API } from "../../../../../apis";
import { Table } from "antd";
import swal from "sweetalert";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import "./styles/homemodifications.css";
import axios from "axios";
import formatPhoneNumber from "../../../../../helpers/formatephoneNumber";
import deathApi from "../../../../../apis/death.api";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
export default function HomeModification() {
  const [fields, setFields] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [moduleName, setModuleName] = useState(null);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const inputFileRef = useRef(null);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [tableData, setTableData] = useState({
    currentModificationsData: [],
    plannedModificationsData: [],
    uploadDocumentHomeModificationsData: [],
  });

  const showModal = async (moduleName) => {
    setLoading(true);
    setModalTitle(moduleName);
    setIsModalVisible(true);
    setModuleName(moduleName);
    setFields(null);
    await getAttribute(moduleName);
  };
  const viewModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("View Item");
    setFields(null);
    await getAttribute(record.module);
  };
  const updateModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("Update");
    setFields(null);
    await getAttribute(record.module);
  };
  // Handle Input Change
  const handleChange = (e) => {
    console.log("eeeeeee", e.target);
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageUpload = async (event) => {
    console.log("e.target", event.target);
    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      setFormData((prev) => ({
        ...prev,
        ["Document Upload"]: res,
        ["Uploaded File Name"]: fileName,
      }));
    }
    inputFileRef.current.value = null;
  };
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const handleItemsInfoSelect = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCreate = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setFormData(null);
      setLoading(false);
    }
  };
  const deleteRecord = async (record) => {
    try {
      setLoading(true);
      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));

      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setFormData(null);
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
    } finally {
      setFormData(null);
      setLoading(false);
    }
  };
  const moduleNames = [
    "Current Modifications",
    "Planned Modifications",
    "Upload Document Home Modifications",
  ];

  const fetchData = async (moduleName) => {
    try {
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("tableData", tableData);

  const handelCloseModal = () => {
    setIsModalVisible(false);
  };
  const getAttribute = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(moduleName);
      console.log("resresres", res);
      if (res && res.statusCode === 200) {
        setFields(res);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };

  useEffect(() => {
    fetchAllModulesData();
  }, []);
  console.log("tableData", tableData);
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };
  const modificationColsdata = [
    {
      title: "Modification",
      dataIndex: "Modification ",
      key: "modification",
      render: (text) => text || "N/A",
    },
    {
      title: "Cost Estimate",
      dataIndex: "Cost Estimate",
      key: "costEstimate",
      render: (record) =>
        record
          ? `$ ${record.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "--------",
    },
    {
      title: "Contractor Name",
      dataIndex: "Contractor Name",
      key: "contractorName",
      render: (text) => text || "N/A",
    },
    {
      title: "Contractor Phone Number",
      dataIndex: "Contractor Phone Number",
      key: "contractorPhoneNumber",
      render: (text) => {
        if (!text) return "N/A";
        return formatPhoneNumber(text);
      },
    },

    {
      title: "Permit Requirements",
      dataIndex: "Permit Requirements ",
      key: "permitRequirements",
      render: (text) => text || "N/A",
    },
    {
      title: "Uploaded Document",
      dataIndex: "Document Upload",
      key: "Document Upload",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a style={{ color: "#7d8fb3" }} href={record["Document Upload"]} target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        viewModal(record);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        setDropdown(false);
                        updateModal(record);
                      }}
                    >
                      Update
                    </li>

                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  const uploadDocCols = [
    {
      title: "Document Name",
      dataIndex: "Uploaded File Name",
      key: "Uploaded File Name",
      render: (fileName, record) => {
        return record["Document Upload"] ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {" "}
            <a style={{ color: "#7d8fb3" }} href={record["Document Upload"]} target="blank">
              {" "}
              {record["Uploaded File Name"] || extractFileNameFromUrl(record["Document Upload"])}
            </a>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            {" "}
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon"></img>{" "}
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => setDropdown(false)}
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    zIndex: "999",
                  }}
                />
                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        window.open(record["Document Upload"]);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      // style={{opacity :record.managedBy==="Plaid" ? "0.3" : "1", cursor: record.managedBy==="Plaid" ? "not-allowed" : "pointer", pointerEvents: record.managedBy === "Plaid" ? "none" : "",  }}
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];
  return (
    <>
      <div className="primary-caregiver-container">
        <div className="legal-document-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="primary-caregiver-title">Home Modifications</h2>
          <ToolTipCreator name={"Disability_Home_Modifications"}/>
        </div>
        </div>
        {/* <div className="primary-caregiver-icon-container">
          <img src={helpIcon} alt="help" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      <div className="primary-caregiver-box-container">
        <div className="primary-caregiver-header-container">
          <h3 className="primary-caregiver-box-title">Current Modifications</h3>
          <div
            className="primary-caregiver-add-button-container"
            onClick={() => showModal("Current Modifications")}
            style={{ cursor: "pointer" }}
          >
            <img src={addIcon} alt="" width={"24px"} height={"24px"} />
          </div>
        </div>
        <div className="primary-caregiver-table-container">
          <Table columns={modificationColsdata} dataSource={tableData.currentModificationsData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div>
        <CustomModal
          show={isModalVisible}
          fields={fields && fields}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? handleCreate : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={handleImageUpload}
          loading={loading}
        />
      </div>

      <div className="primary-caregiver-box-container">
        <div className="primary-caregiver-header-container">
          <h3 className="primary-caregiver-box-title">Planned Modifications</h3>
          <div
            className="primary-caregiver-add-button-container"
            onClick={() => showModal("Planned Modifications")}
            style={{ cursor: "pointer" }}
          >
            <img src={addIcon} alt="" width={"24px"} height={"24px"} />
          </div>
        </div>
        <div className="primary-caregiver-table-container">
          <Table columns={modificationColsdata} dataSource={tableData.plannedModificationsData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="upload-document-container">
        <div className="upload-document-header-container">
          <div className="upload-document-header-title-container">
            <h3 className="header-title">Upload Document</h3>
          </div>
          <div className="upload-document-button-container" style={{ cursor: "pointer" }}>
            <label
              htmlFor="UploadDocumentMedicalhistory"
              onClick={() => {
                setModuleName("Upload Document Home Modifications");
              }}
              style={{ cursor: "pointer" }}
            >
              <img src={addIcon} alt="Add File" width="24px" height="24px" />
            </label>
            <input
              type="file"
              id="UploadDocumentMedicalhistory"
              hidden
              ref={inputFileRef}
              onChange={async (event) => {
                await handleImageUpload(event);
              }}
              accept="image/jpeg, .pdf, .xlsx, .doc"
            />
          </div>
        </div>

        <div className="upload-document-table-container">
          <Table columns={uploadDocCols} dataSource={tableData.uploadDocumentHomeModificationsData} />
          <NewLoader isLoading={loading} />
        </div>
      </div>
    </>
  );
}
